"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextLink = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const TextLink = ({
  testId,
  ...props
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledLink, {
    "data-testid": testId ?? getTestId(_constants.TEXT_LINK),
    ...props
  });
};
exports.TextLink = TextLink;
//# sourceMappingURL=TextLink.js.map